import { useShallow } from 'zustand/react/shallow';
import { identityFromSession, useSessionStore } from 'stores/sessionStore';
import { type SessionIdentity } from 'stores/sessionIdentity';
import { isAccountReady } from 'stores/sessionReadiness';

export const useSessionMemberEmail = (): string | null =>
  useSessionStore((state) => state.member?.email_address ?? null);

export const useSessionAccountReady = (): boolean =>
  useSessionStore(
    (state) =>
      state.isAuthenticated && isAccountReady(state.member, state.organization)
  );

export const useSessionIdentity = (): SessionIdentity =>
  useSessionStore(
    useShallow((state) =>
      identityFromSession(
        state.isAuthenticated,
        state.member,
        state.organization
      )
    )
  );

export const useSessionVerification = () =>
  useSessionStore(
    useShallow((store) => ({
      isLoading: store.isLoading,
      isProvisional: store.isProvisional,
      isAuthenticated: store.isAuthenticated,
      isAccountReady:
        store.isAuthenticated &&
        isAccountReady(store.member, store.organization),
      authToken: store.authToken,
      member: store.member,
      organization: store.organization,
      setAuthenticatedSession: store.setAuthenticatedSession,
      logout: store.logout,
      refreshSession: store.verifySession,
      setOrganizationUiLanguage: store.setOrganizationUiLanguage,
    }))
  );
